import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import styled from "styled-components"
import getGatsbyImage from "utils/getGatsbyImage"
import Plans from "../../UI/Plans"
import { formatStrapiPlanToPlanProps } from "../StrapiPlanHero"

const Wrapper = styled.div`
  position: relative;
  > :first-child {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
`

interface IProps {
  plans: any[]
  backgroundImage: any
}

const StrapiPlansSection = (props: IProps) => {
  const plans = props.plans.map(plan => ({
    ...formatStrapiPlanToPlanProps(plan),
    linkTo: `/parents/checkout/${plan.planId}`,
  }))

  return (
    <Wrapper className="PlansSection MorePlans">
      {props.backgroundImage ? (
        <GatsbyImage
          image={getGatsbyImage(props.backgroundImage.localFile)}
          alt=""
        />
      ) : (
        <div />
      )}
      <Plans plans={plans} />
    </Wrapper>
  )
}

export default StrapiPlansSection
